   <!-- <mat-sidenav-container class="app-container">
  <mat-sidenav #drawer mode="side" [opened]="true" class="app-sidenav">
    <div class="logo-container">
      <h2 class="app-name">  <img   src="/assets/images/Letter.jpg"></h2>
      
    </div>
 <mat-nav-list>

      
      <a mat-list-item routerLink="/dashboard" routerLinkActive="active">
        <mat-icon>dashboard</mat-icon>
        Dashboard
      </a>

          <a mat-list-item class="nested"  (click)="isMasterExpanded = !isMasterExpanded" routerLinkActive="active">
<mat-icon>person</mat-icon>Master     <mat-icon class="expand-icon">
      {{ isMasterExpanded ? 'expand_less' : 'expand_more' }}
    </mat-icon></a>
      <div *ngIf="isMasterExpanded" class="submenu">
                <a mat-list-item class="nested" routerLink="/home/empmastergrid" routerLinkActive="active">
<mat-icon>arrow_right </mat-icon>Employee Master</a></div>
      
      <a mat-list-item class="nested" (click)="isEmployeeExpanded = !isEmployeeExpanded" routerLinkActive="active">
        <mat-icon>people</mat-icon>
        Onboarding/Offboarding
          <mat-icon class="expand-icon">
      {{ isEmployeeExpanded ? 'expand_less' : 'expand_more' }}
    </mat-icon>
      </a>

      <div *ngIf="isEmployeeExpanded" class="submenu">
      <a mat-list-item class="nested-child" routerLink="/home/emponboardingform" routerLinkActive="active">
            <mat-icon>arrow_right</mat-icon>
        Onboarding/Offboarding 
      </a>
     
      <a mat-list-item class="nested-child" routerLink="/home/emponboardinggrid" routerLinkActive="active">
            <mat-icon>arrow_right</mat-icon>
        Onboarding/Offboarding Request Form
      </a>
   
      <a mat-list-item class="nested-child" routerLink="/home/checkerData" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        Checker Review
      </a>
      
      <a mat-list-item class="nested-child" routerLink="/home/finalappgrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        Final Approver
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/accountcreation" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        IT Creation
      </a>
      
      <a mat-list-item class="nested-child" routerLink="/home/hrclosuregrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        HR Closure
      </a> 
</div>

      <a mat-list-item class="nested" (click)="toggleItFacility()" routerLinkActive="active">
        <mat-icon>people</mat-icon>
        IT Facility 
          <mat-icon class="expand-icon">
      {{ isItFacilityExpanded ? 'expand_less' : 'expand_more' }}
    </mat-icon>
      </a>
<div *ngIf="isItFacilityExpanded" class="submenu">
      <a mat-list-item class="nested-child" routerLink="/home/itfacilityform" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        IT Facility
      </a>
      
      <a mat-list-item class="nested-child" routerLink="/home/itfacilityrejectiongrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        IT Facility Ammendment
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/checkeritfacility" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        Checker IT Facility
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/checker-itfacility-rejgrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        Checker Rejected Form
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/finalitfacility" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        Final IT Facility
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/final-itfacility-rejgrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        Final Rejected Form
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/itfacilitycloser" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       IT Facility Closure
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/itfacilitychecker-declinegrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       IT Facility Checker Decline
      </a>
      
      </div>


       <a mat-list-item class="nested" (click)="isITRevokeexpanded = !isITRevokeexpanded" routerLinkActive="active">
        <mat-icon>people</mat-icon>
        ITFacility Revoke 
          <mat-icon class="expand-icon">
      {{ isITRevokeexpanded ? 'expand_less' : 'expand_more' }}
    </mat-icon></a>
<div *ngIf="isITRevokeexpanded" class="submenu">
<a mat-list-item class="nested-child" routerLink="/home/itfacility-revoke" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        IT Facility Revocation
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/CheckerRevokeGrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        Checker 
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/FinalRevokeGrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
        Final Approver
      </a>
</div>




      <a mat-list-item class="nested" (click)="isMicrosoftexpanded = !isMicrosoftexpanded" routerLinkActive="active">
        <mat-icon>people</mat-icon>
        Microsoft Dynamic 360 
          <mat-icon class="expand-icon">
      {{ isMicrosoftexpanded ? 'expand_less' : 'expand_more' }}
    </mat-icon></a>
      <div *ngIf="isMicrosoftexpanded" class="submenu">
      <a mat-list-item class="nested-child" routerLink="/home/microsoft-itfacilitygrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       Microsoft 360 checker Approver
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/microsoft-checker-rejgrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       Microsoft 360 checker Rejection
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/microsoft-finalapprgrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       Microsoft 360 Final Approver
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/Microsoft-itfacilitycloser" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       Microsoft 360 IT Closure Approver
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/microsoft-rejectionformgrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       Microsoft 360 Rejection Form
      </a>
    
      </div>
     
       <a mat-list-item class="nested" (click)="isTicketexpanded = !isTicketexpanded " routerLinkActive="active">
        <mat-icon>people</mat-icon>
        Tickets 
          <mat-icon class="expand-icon">
      {{ isTicketexpanded ? 'expand_less' : 'expand_more' }}
    </mat-icon></a>
    <div *ngIf="isTicketexpanded" class="submenu">
      <a mat-list-item class="nested-child" routerLink="/home/ticket-creation" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       Ticket Creation
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/Ticket-Grid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       IT Review
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/TicketStatusView" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       Ticket Status
      </a>
      <a mat-list-item class="nested-child" routerLink="/home/Maintaince-Ticket" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       Maintaince Ticket
      </a>
    </div>
    <a mat-list-item class="nested" (click)="isSettingsExpanded = !isSettingsExpanded" routerLinkActive="active">
        <mat-icon>settings</mat-icon>
        Settings 
          <mat-icon class="expand-icon">
      {{ isSettingsExpanded ? 'expand_less' : 'expand_more' }}
    </mat-icon></a>
    <div *ngIf="isSettingsExpanded" class="submenu">
      <a mat-list-item class="nested-child" routerLink="/home/User-MasterGrid" routerLinkActive="active">
           <mat-icon>arrow_right</mat-icon>
       User Master
      </a>
    </div>
       <a mat-list-item routerLink="/settings" routerLinkActive="active">
        <mat-icon>settings</mat-icon>
        User-MasterGrid
      </a> 
    </mat-nav-list>


  </mat-sidenav>

  <mat-sidenav-content>
  
    <mat-toolbar color="primary" class="custom-toolbar">
      <button mat-icon-button (click)="drawer.toggle()" aria-label="Menu">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="app-title">OnlineTicketingTool</span>
      <span class="spacer"></span>
      <div class="user-section">
        <div class="Username">HI! {{appservice.username}}</div>
        <button mat-icon-button aria-label="User Profile">
          <mat-icon>account_circle</mat-icon>
        </button>
        <button mat-button color="accent" class="logout-btn" (click)="logout()">Logout</button>
      </div>
    </mat-toolbar>

    
    <div class="content">
      <router-outlet></router-outlet>
    </div>

    
    <mat-toolbar class="footer">
    
    </mat-toolbar>
  </mat-sidenav-content>
</mat-sidenav-container>
 -->

 <mat-sidenav-container class="app-container">
  <mat-sidenav mode="side" opened class="app-sidenav">

    <div class="logo-container">
      <img src="/assets/images/Letter.jpg" />
    </div>

    <mat-nav-list>

      
      <a mat-list-item routerLink="/dashboard" routerLinkActive="active">
        <mat-icon>dashboard</mat-icon>
        Dashboard
      </a>

      <!-- Dynamic Menu -->
      <ng-container *ngFor="let menu of menuList">

  <!-- Parent Menu -->
  <a mat-list-item
     class="nested"
     (click)="menu.Children ? toggleMenu1(menu) : null"
     [routerLink]="!menu.Children ? menu.route : null"
     [class.active]="menu.expanded">

    <mat-icon>{{ menu.icon || 'folder' }}</mat-icon>
    {{ menu.MM_Display_Name }}

    <mat-icon *ngIf="menu.Children" class="expand-icon">
      {{ menu.expanded ? 'expand_less' : 'expand_more' }}
    </mat-icon>
  </a>

  <!-- Child Menu -->
  <div *ngIf="menu.Children?.length && menu.expanded" class="submenu">
  <a mat-list-item
     class="nested-child"
     *ngFor="let child of menu.Children"
     [routerLink]="child.route"
     routerLinkActive="active">
    <mat-icon>arrow_right</mat-icon>
    {{ child.MM_Display_Name }}
  </a>
</div>
</ng-container>


    </mat-nav-list>

  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary" class="custom-toolbar">
      <!-- <button mat-icon-button (click)="drawer.toggle()" aria-label="Menu">
        <mat-icon>menu</mat-icon>
      </button> -->
      <span class="app-title">OnlineTicketingTool</span>
      <span class="spacer"></span>
      <div class="user-section">
        <div class="Username">HI! {{appservice.username}}</div>
        <button mat-icon-button aria-label="User Profile">
          <mat-icon>account_circle</mat-icon>
        </button>
        <button mat-button color="accent" class="logout-btn" (click)="logout()">Logout</button>
      </div>
    </mat-toolbar>

    
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    <mat-toolbar class="footer">  
    </mat-toolbar>
  </mat-sidenav-content>
</mat-sidenav-container>
